/**
* Cards Slider JS
* -----------------------------------------------------------------------------
*
* All the JS for the Cards Slider component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
// gsap.registerPlugin( ScrollTrigger );
( function( app ) {
  const COMPONENT = {

    className: 'cards-slider',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      $( function() {
        $( '.cards-slider' ).each( function( key, component ) {
          // Initialize Slick Slider
          $( component ).find( '.cards-slider__slider' ).slick( {
            dots: false,
            arrows: true,
            prevArrow: $( component ).find( '.prev-slide' )[0],
            nextArrow: $( component ).find( '.next-slide' )[0],
            slidesToShow: 3,
            speed: 1000,
            infinite: false,
            responsive: [
              {
                breakpoint: 1024,
                settings: {
                  slidesToShow: 2,
                },
              },
              {
                breakpoint: 768,
                settings: {
                  slidesToShow: 1.15,
                },
              },
            ],
          } );
          // Function to filter slides based on screen size
          function toggleDesktopOnlySlides() {
            const isMobile = window.innerWidth < 768;
            $( component ).find( '.cards-slider__slider' ).slick( 'slickUnfilter' ); // Remove previous filter
            if ( isMobile ) {
              $( component ).find( '.cards-slider__slider' ).slick( 'slickFilter', function( index, slide ) {
                return !$( slide ).hasClass( 'desktop-only' );
              } );
            }
          }
          // Initial filter and on window resize
          toggleDesktopOnlySlides();
          const toggleSlides = new app.components.common.Throttle( toggleDesktopOnlySlides, 250 );
          $( window ).on( 'resize', function() {
            toggleSlides.run();
          } );
          // Custom transformation on slide change
          $( component ).find( '.cards-slider__slider--conditions, .cards-slider__slider--treatments' ).on( 'beforeChange', function( event, slick, currentSlide, nextSlide ) {
            $( component ).find( '.cards-slider__slide' ).each( function( cardKey, card ) {
              const newTranslate = nextSlide * 4 > 25 ? 25 : nextSlide * 4;
              $( card ).find( '.fit-image' ).css( 'transform', 'translateX(-' + ( 50 - newTranslate ) + '%)' );
            } );
          } );
        } );
      } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'cards-slider', COMPONENT );
} )( app );
